/**
 * Extracts and maps URL search parameters based on provided mappings
 * @param searchParams - URLSearchParams or similar object with a get method
 * @param paramMappings - Object mapping query parameter keys to result keys
 * @returns Object containing the mapped parameters
 */
export const extractQueryParams = (
  searchParams: { get(key: string): string | null },
  paramMappings: Record<string, string>
) => {
  const params: Record<string, string> = {};

  Object.entries(paramMappings).forEach(([queryKey, resultKey]) => {
    const value = searchParams.get(queryKey);
    if (value) {
      params[resultKey] = value;
    }
  });

  return params;
};
